export const notFound = {
  redirect: {
    permanent: false,
    destination: '/not_found',
  },
}

export const serviceUnavailable = {
  redirect: {
    permanent: false,
    destination: '/service_unavailable',
  },
}

const NEXT_DATA_PATH_REGEX = /^\/_next\/data\/[^/]+\/(.+)\.json$/
const AUTH_QUERY_PARAMS = ['p', 'redirect_path']
const ABSOLUTE_URL_REGEX = /^https?:\/\//i

const getPathAndSearchParams = (
  redirectUrl: string
): { pathname: string; searchParams: URLSearchParams } => {
  if (ABSOLUTE_URL_REGEX.test(redirectUrl)) {
    const url = new URL(redirectUrl)

    return {
      pathname: url.pathname,
      searchParams: url.searchParams,
    }
  }

  const [pathname = '/', search = ''] = redirectUrl.split('?')

  return {
    pathname,
    searchParams: new URLSearchParams(search),
  }
}

export const getAuthRedirectPath = (redirectUrl?: string): string => {
  if (!redirectUrl) return '/'

  const { pathname: redirectPathname, searchParams } =
    getPathAndSearchParams(redirectUrl)
  const nextDataPathMatch = redirectPathname.match(NEXT_DATA_PATH_REGEX)
  const pathname = nextDataPathMatch?.[1]
    ? `/${nextDataPathMatch[1]}`
    : redirectPathname

  AUTH_QUERY_PARAMS.forEach((key) => searchParams.delete(key))

  const search = searchParams.toString()

  const queryString = search ? `?${search}` : ''
  return `${pathname}${queryString}`
}

export const countryNotSupported = {
  redirect: {
    permanent: false,
    destination: '/country_not_supported',
  },
}

export const notAuthorized = (redirectUrl: string) => ({
  redirect: {
    permanent: false,
    destination: `/login?redirect_path=${encodeURIComponent(
      getAuthRedirectPath(redirectUrl)
    )}`,
  },
})
